export const EShapeBarPosition = wcardinal.ui.EShapeBarPosition;